import http from './http';
import Alert from './alert';

export function downloadScheduleListPdf({ placeId, idProf, idSpec, start, end, groupBy }) {
  return http.get(`/places/${placeId}/schedules/download-pdf`, {
    params: {
      id_prof: idProf,
      id_spec: idSpec,
      start_date: start,
      end_date: end,
      base: 'AL',
      group_by: groupBy,
    },
    responseType: 'blob',
  }).then((response) => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = fileURL;
    document.body.appendChild(iframe);
    iframe.onload = function () {
      iframe.contentWindow.print();
    };
  }).catch((error) => {
    console.error('Download error:', error);
    Alert.toastError('Não foi possível baixar a lista de pacientes.');
    return Promise.reject(error);
  });
}
